import { FC, ChangeEvent } from 'react';

import Input from '../../../shared/components/Input';
import StateSelect from '../../../shared/components/StateSelect';
import { STATE_PROVINCE_LABEL, ADDRESS_FIELDS } from '../constants/billingDetails.constants';

import { addressConfig, AddressFieldConfig } from './addressConfig';

interface DynamicRules {
    showState?: boolean;
    showBuilding?: boolean;
}

interface ManualAddressFormProps {
    country: string;
    address: Record<string, string>;
    onChange: (key: string, value: string) => void;
    errors?: Record<string, string>;
    dynamicRules?: DynamicRules;
    onInteraction?: () => void;
}

const ManualAddressForm: FC<ManualAddressFormProps> = ({ country, address, onChange, errors = {}, dynamicRules, onInteraction }) => {
    let fields: AddressFieldConfig[] = addressConfig[country] || addressConfig.DEFAULT;

    // Apply dynamic rules from Loqate "dry-run"
    if (dynamicRules) {
        // Handle State/Province
        if (dynamicRules.showState) {
            // Ensure State field exists if it's not already in the config
            const hasState = fields.find(f => f.key === ADDRESS_FIELDS.STATE || f.key === ADDRESS_FIELDS.REGION || f.key === ADDRESS_FIELDS.PROVINCE);
            if (!hasState) {
                // Determine where to insert 'state'. Usually after 'city' or before 'zip/postcode'
                const cityIndex = fields.findIndex(f => f.key === ADDRESS_FIELDS.CITY);
                const stateField: AddressFieldConfig = { key: ADDRESS_FIELDS.STATE, label: STATE_PROVINCE_LABEL, widthClass: 'w-full md:w-1/2' };
                
                if (cityIndex !== -1) {
                    const newFields = [...fields];
                    newFields.splice(cityIndex + 1, 0, stateField);
                    fields = newFields;
                } else {
                    fields = [...fields, stateField];
                }
            }
        } else {
             fields = fields.filter(f => {
                if (f.key === ADDRESS_FIELDS.STATE || f.key === ADDRESS_FIELDS.REGION || f.key === ADDRESS_FIELDS.PROVINCE) {
                    return dynamicRules.showState;
                }
                return true;
            });
        }
    }

    return (
        <div className="flex flex-wrap gap-x-[12px] w-[295px] md:w-[640px] xl:w-[573px]">
            {fields.map(field => (
                <div key={field.key} className={`mb-[12px] md:mb-[20px] ${field.widthClass || 'w-full'}`}>
                    {field.key === ADDRESS_FIELDS.STATE ? (
                        <StateSelect
                            countryCode={country}
                            label={field.label}
                            value={address[field.key] || ''}
                            onChange={(val) => onChange(field.key, val)}
                            error={errors[field.key]}
                            onInteraction={onInteraction}
                            labelWidthClass={field.labelWidthClass}
                        />
                    ) : (
                        <Input
                            label={field.label}
                            name={field.key}
                            value={address[field.key] || ''}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(field.key, e.target.value)}
                            placeholder=""
                            error={errors[field.key]}
                            optional={field.optional}
                            onFocus={() => onInteraction && onInteraction()}
                            labelClassName="!text-[#344054]"
                            inputClassName="!border-[#667085] !py-[10px] !px-[12px]"
                            labelWidthClass={field.labelWidthClass}
                        />
                    )}
                </div>
            ))}
        </div>
    );
};


export default ManualAddressForm;
